import MuiTextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import React from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { createTextMaskInputElement } from 'text-mask-core';

const TextFieldFocusTracker = (textField) =>
  React.createClass({
    getInitialState: function () {
      return { hasFocus: false };
    },
    render: function () {
      return React.createElement(
        textField,
        Object.assign({}, this.props, {
          hasFocus: this.state.hasFocus,
          onFocus: () => this.setState({ hasFocus: true }),
          onBlur: () => this.setState({ hasFocus: false })
        })
      );
    }
  });

const TextFieldValidator = (TextField) => {
  const Component = ({ value, hasFocus, validate, ...props }) => (
    <TextField
      {...props}
      value={value}
      errorText={hasFocus || value == null ? '' : validate(value)}
    />
  );

  Component.propTypes = {
    value: PropTypes.any,
    hasFocus: PropTypes.bool.isRequired,
    validate: PropTypes.func.isRequired
  };

  return Component;
};

const ValidatedTextField = (textField) => {
  const Component = TextFieldFocusTracker(TextFieldValidator(textField));

  return ({ validate, ...props }) => <Component {...props} validate={validate || (() => '')} />;
};

const TextField = ValidatedTextField(({ onChange, value, ...props }) => (
  <MuiTextField {...props} onChange={(event) => onChange(event.target.value)} value={value || ''} />
));

const MaskedField = ({ mask, pipe = (x) => x }) =>
  class extends React.Component {
    constructor(props) {
      super(props);
    }

    componentDidMount() {
      this.textMaskInputElement = createTextMaskInputElement({
        inputElement: this.inputElement,
        mask,
        pipe,
        guide: false
      });
      this.textMaskInputElement.update(this.props.value);
    }

    componentWillUnmount() {
      this.textMaskInputElement = null;
    }

    render() {
      const { value, onChange, ...props } = this.props;

      return (
        <MuiTextField
          {...props}
          defaultValue={value == null ? '' : value}
          ref={(element) => (this.inputElement = element && element.input)}
          onChange={() => {
            this.textMaskInputElement.update();
            onChange(this.inputElement.value);
          }}
        />
      );
    }
  };

const NumberTextField = (prefix, decimalLimit, suffix, inputProps) => {
  const MaskedNumberField = ValidatedTextField(
    MaskedField({
      mask: createNumberMask({ prefix, suffix, decimalLimit, allowDecimal: true }),
      pipe: (value) => {
        let num = value.replace(/[^\d.,]/g, '');
        if (num.length > 1) {
          if (!num.startsWith('0.')) num = parseFloat(num) === 0 ? '0' : num.replace(/^0+/, '');
          return num ? prefix + num + suffix : '';
        }
        return value;
      }
    })
  );

  const Component = ({ validate, onChange, ...props }) => (
    <MaskedNumberField
      {...inputProps}
      {...props}
      validate={(num) => Component.validate(num, validate)}
      onChange={(value) => {
        const num = parseFloat(value.replace(/[^\d.]/g, ''));
        onChange(isNaN(num) ? null : num);
      }}
    />
  );
  Component.validate = (num, customValidator = () => '') =>
    num != null && !isNaN(num) ? customValidator(num) : 'Please enter a valid number';
  return Component;
};

const androidKeyboardCheck = {
  type: navigator.userAgent.toLowerCase().indexOf('android') > -1 ? 'tel' : 'text'
};

const PercentTextField = NumberTextField('', null, '%', androidKeyboardCheck);
const DollarTextField = NumberTextField('$', 2, '', androidKeyboardCheck);
const CurrencyTextField = NumberTextField('$', 2, '', {});

export { TextField, PercentTextField, DollarTextField, CurrencyTextField };



// WEBPACK FOOTER //
// ./src/components/MaskedTextField.js